import { createStore } from 'redux';
import createReducer from './reducers';
import throttle from 'lodash/throttle';
import { all } from 'redux-saga/effects';
import { applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';
import { logger } from 'redux-logger';
import { PERSISTED_STATE_KEY } from '../config/settings';
import jwt_decode from 'jwt-decode';
import isPromise from 'is-promise';
import Login from '../views/containers/Login/state';
import { logoutUser } from '../views/containers/Login/state/operations';
import Dropdowns from '../views/components/Common/BaseAutocomplete/state';

const saveState = (state) => {
    try {
        localStorage.setItem(PERSISTED_STATE_KEY, JSON.stringify(state));
    } catch (e) { }
};

// Store methods
const loadState = () => {
    try {
        const serializedState = localStorage.getItem(PERSISTED_STATE_KEY);
        return null === serializedState ? undefined : JSON.parse(serializedState);
    } catch (e) { return undefined; }
};

const initialState = {
    auth: Login.reducer,
    dropdown: Dropdowns.reducer,
    // nested: NestedReducer,
};

let persistedState = loadState();
if (persistedState) {
    let nPersistedState = {};
    let preloadedKeys = Object.keys(initialState);
    Object.keys(persistedState).forEach(key => {
        if (preloadedKeys.indexOf(key) > -1) {
            nPersistedState[key] = persistedState[key];
        }
    })
    persistedState = nPersistedState;
}

export const sagaMiddleware = createSagaMiddleware();

const loaderHandler = ({ dispatch }) => next => action => {
    if (isPromise(action)) {
        dispatch({ type: 'SHOW_BASE_LOADER' })
        action
            .then(() => dispatch({ type: 'HIDE_BASE_LOADER' }))
            .catch(() => dispatch({ type: 'HIDE_BASE_LOADER' }))
    }
    return next(action)
}

export const checkTokenExpirationMiddleware = store => next => action => {
    const savedStates = JSON.parse(localStorage.getItem(PERSISTED_STATE_KEY))
    const token = savedStates && savedStates['auth']['credentials']['authToken']

    if (token && jwt_decode(token).exp < Date.now() / 1000) {
        // TODO: dispatch a logout or call refresh token
        store.dispatch(logoutUser());
    }

    next(action);
};

const middleware = applyMiddleware(
    thunkMiddleware,
    checkTokenExpirationMiddleware,
    logger, // comment this line to disable logger
    sagaMiddleware,
);


const store = createStore(createReducer(), persistedState, middleware);
// Add a dictionary to keep track of the registered async reducers
store.asyncReducers = {
}


// Module sagas
function *rootSaga() {
    yield all([
        // Insert module sagas
    ])
}

export default function configureStore() {
    // Create an inject reducer function
    // This function adds the async reducer, and creates a new combined reducer
    store.injectReducer = (key, asyncReducer) => {
        if (Object.hasOwnProperty.call(store.asyncReducers, key)) return;

        store.asyncReducers[key] = asyncReducer
        store.replaceReducer(createReducer(store.asyncReducers))
    }

    store.subscribe(throttle(() => {
        saveState(store.getState());
    }), 1000);

    sagaMiddleware.run(rootSaga)

    // Return the modified store
    return store
}

export function getStore() {
    return store
}
